var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'text-secondary': _vm.isOpened },on:{"click":_vm.toggle}},[_c('span',{staticClass:"fas fa-search"}),_vm._v(" "),(_vm.isOpened)?_c('portal',{attrs:{"to":"header"}},[_c('AlgoliaSearch',{attrs:{"hits-per-page":_vm.hitsPerPage,"placeholder":_vm.placeholder,"show-close":true},on:{"close":_vm.dismiss}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }